import ConvertNumberToWordsInterface from '../../domain/Convert/ConvertNumberToWordsInterface';
import n2words from 'n2words'

export default class NumberToWordConverter implements ConvertNumberToWordsInterface {
  convert(valueToConvert:number): string {
    return n2words(valueToConvert, {lang: 'fr'})
  }
}
